// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3sF61","requiredAsterisk":"Info_requiredAsterisk__38sMi"};